<script>
	import { Icon } from '@ctm/icons';
	import { Notifications } from '@ctm/icons/interface';
</script>

<button class="beamerTrigger">
	<Icon icon={Notifications} size="lg" />
</button>

<style>
	.beamerTrigger {
		align-items: center;
		background: none;
		border: none;
		display: flex;
		color: var(--n9);
		justify-content: center;
		padding: 0 16px;
	}

	.beamerTrigger:focus,
	.beamerTrigger:hover {
		color: inherit;
		outline: none;
	}
</style>
